/**
 * Program: Mixin for Common Routing
 * Author: soonh94.hong
 * Description: Mixin for Common Routing
 */

export default {
  methods: {
    /**
     * param: path (String)
     * return: nothing
     * exception: nothing
     * description: 새 탭 오픈 / router push 핸들링 (handling open with new tab / router push)
     * since: 2023.12.28
     */
    handleRouterPush(path) {
      const option = {
        once: true,
      };
      document.addEventListener('click', (e) => {
        if (this.isOpenNewTab(e)) window.open(path, '_blank');
        else this.$router.push({ path });
      }, option);
    },
    /**
     * param: event (Object)
     * return: nothing
     * exception: nothing
     * description: 새 탭으로 오픈하는지 여부 (Whether open with new tab or not)
     * since: 2023.12.28
     */
    isOpenNewTab(e) {
      return e.ctrlKey;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixin/RouterCommon.js